// src/redux/ProviderSubscriptionSlice.js

import { createSlice } from '@reduxjs/toolkit';

// Initial state for subscription
const initialState = {
  isSubscribed: false, // false by default
};

const ProviderSubscriptionSlice = createSlice({
  name: 'providerSubscription',
  initialState,
  reducers: {
    setSubscriptionStatus: (state, action) => {
      state.isSubscribed = action.payload; // Payload should be true or false
    },
  },
});

// Export actions
export const { setSubscriptionStatus } = ProviderSubscriptionSlice.actions;

// Export reducer
export default ProviderSubscriptionSlice.reducer;
